export const MAX_UUID = 2n ** 122n;
export const WIDTH_TO_SHOW_DOUBLE_HEIGHT = 768;
export const SCROLLBAR_WIDTH = 24;
export const ITEM_HEIGHT = 24;

export const querySmallScreen = `(max-width: ${WIDTH_TO_SHOW_DOUBLE_HEIGHT}px)`;
export const queryVerySmallScreen = `(max-width: 550px)`;
